import React from "react";
import { v4 as uuidv4 } from 'uuid';
import { Line, Bar, Pie } from 'react-chartjs-2';
import { nanoid } from "nanoid";
import { addTopic, removeTopic } from "../../utils/socket.services";
import HttpServices from "../../utils/Http.services";
import { getOneThing } from "../../utils/useful";
// import zoomPlugin from 'chartjs-plugin-zoom';
// import zoom from 'chartjs-plugin-zoom'
import Chart from "../../components/widgets/Chart.jsx";


class ChartWidget extends React.Component {

    state = {
        show: true,

        // data: [],
        data: {
            labels: [],
            datasets: []
            //     {
            //         label: 'Temperature',
            //         data: [],
            //         fill: false,
            //         backgroundColor: 'rgb(255, 99, 132)',
            //         borderColor: 'rgba(255, 99, 132, 0.2)',
            //         // yAxisID: 'y-axis-1',
            //     },
            // ]
        },

        thing: {},
        topicId: nanoid(10),

        timeChartOptions: {
            bezierCurve: false,
            // legend: {
            //     display: false
            // },
            elements: {
                line: {
                    tension: 0
                }
            },
            pan: {
                enabled: true,
                mode: 'x',
                speed: 1
                // ...
            },
            zoom: {
                enabled: true,
                // drag:true,
                mode: 'x'
            },

            scales: {
                xAxes: [
                    {
                        type: "time",
                        autoSkip: true,
                        // maxTicksLimit: 20,
                        time: {
                            // unit: 'week',
                            displayFormats: {
                                hour: "MMM DD"
                            },
                            tooltipFormat: "MMM DD hh:mm"
                        }
                    }
                ],
                yAxes: [
                    {
                        ticks: {
                            beginAtZero: true,

                        }
                    }
                ]
            }
        },

    }


    colors = [
        { backgroundColor: 'rgb(255, 99, 132)', borderColor: 'rgba(255, 99, 132, 0.2)' },
        { backgroundColor: 'rgb(54, 162, 235)', borderColor: 'rgba(54, 162, 235, 0.2)' },
        { backgroundColor: '#90aaee', borderColor: '#90aaee20' }
    ]



    // data = {
    //     labels: [],
    //     datasets: [
    //         {
    //             // label: 'Temperature',
    //             data: [],
    //             fill: false,
    //             backgroundColor: 'rgb(255, 99, 132)',
    //             borderColor: 'rgba(255, 99, 132, 0.2)',
    //             yAxisID: 'y-axis-1',
    //         },
    //         // {
    //         //     label: 'Humidity',
    //         //     data: [1, 2, 4, 1, 2, 3],
    //         //     fill: false,
    //         //     backgroundColor: 'rgb(54, 162, 235)',
    //         //     borderColor: 'rgba(54, 162, 235, 0.2)',
    //         //     yAxisID: 'y-axis-2',
    //         // },
    //         // {
    //         //     label: 'Other',
    //         //     data: [4, 7, 1, 5, 5, 1],
    //         //     fill: false,
    //         //     backgroundColor: '#90aaee',
    //         //     borderColor: '#90aaee20',
    //         //     yAxisID: 'y-axis-3',
    //         // },
    //     ],
    // }

    // options = {
    //     scales: {
    //         yAxes: [
    //             {
    //                 type: 'linear',
    //                 display: true,
    //                 position: 'left',
    //                 id: 'y-axis-1',
    //             },
    //             // {
    //             //     type: 'linear',
    //             //     display: true,
    //             //     position: 'right',
    //             //     id: 'y-axis-2',
    //             //     gridLines: {
    //             //         drawOnArea: false,
    //             //     },
    //             // },
    //             // {
    //             //     // type: 'linear',
    //             //     display: true,
    //             //     position: 'right',
    //             //     id: 'y-axis-3',
    //             //     gridLines: {
    //             //         drawOnArea: false,
    //             //     },
    //             // },
    //         ],
    //     },
    // }





    componentDidMount() {
        this.init()
        window.addEventListener('resize', this.getSize)
        // Chart.register(zoom)
        // Bar.register(zoom)

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getSize)
    }

    getSize = () => {
        this.setState({ show: false, height: window.innerHeight, width: window.innerWidth }, () => {
            this.setState({ show: true })
        })
    }

    componentDidUpdate(prevProps) {
        const widgetData = this.props.widget || this.props.data
        const prevWidgetData = prevProps.widget || prevProps.data
        if (prevWidgetData?.thing != widgetData?.thing) {
            this.init()
        }
    }

    componentWillUnmount() {
        const widgetData = this.props.widget || this.props.data
        if (widgetData?.thing) {
            removeTopic(this.state.topicId, widgetData.thing, 'things')
        }
    }

    init() {
        const widgetData = this.props.widget || this.props.data
        // If no thing is provided, skip initialization (for widgets that don't use things)
        if (!widgetData?.thing) {
            return
        }

        this.setState({ thing: {} }, () => {
            getOneThing({ id: widgetData.thing }, (fetchResult, fetchError, status) => {
                // console.log(fetchResult)
                if (fetchResult) {
                    this.setState({ thing: fetchResult.info }, () => {


                        // let headers = [...this.state.headers]
                        // if (Array.isArray(this.props.data.characteristic)) {
                        //     this.props.data.characteristic.forEach(element => {

                        //         headers.push({ key: "data." + element, type: 'TextInput', information: { label: this.getLabel(element) } })

                        //     });
                        //     this.setState({ headers })
                        // }

                        this.getSize()
                        this.fetchList()
                    })
                }
            })
        })
    }




    fetchList = () => {
        const widgetData = this.props.widget || this.props.data
        if (!widgetData?.thing) {
            return
        }
        
        HttpServices.request("getThingHistory", { filter: { thing: widgetData.thing }, limit: 30 }, (fetchResult, fetchError, status) => {
            addTopic(this.state.topicId, widgetData.thing, 'things', null, this.updateData)
            // console.log(fetchResult)
            if (fetchError) { return }


            let data = this.state.data

            if (!widgetData.characteristic || !Array.isArray(widgetData.characteristic)) {
                return
            }

            widgetData.characteristic.forEach((characteristic, index) => {
                // console.log(index%this.colors.length)
                let color = this.colors[Math.floor(index % this.colors.length)]
                data.datasets.push({ data: [], label: this.getLabel(characteristic), backgroundColor: color.backgroundColor, borderColor: color.borderColor, fill: false })

            });
            // data.datasets[0].data = []// = [{ data: []}]
            data.labels = []
            const widgetData = this.props.widget || this.props.data
            fetchResult.info.forEach(element => {
                data.labels.push(element.cDate)

                if (widgetData.characteristic && Array.isArray(widgetData.characteristic)) {
                    widgetData.characteristic.forEach((characteristic, index) => {
                        data.datasets[index].data.push(element.data[characteristic])
                    })
                }

            });
            // console.log(data)
            this.setState({ data }, () => {
                let timeChartOptions = this.state.timeChartOptions
                timeChartOptions.animation = { duration: 0 }
                this.setState({ timeChartOptions })
            })


            // this.setState({ data: fetchResult.info })
            // if (cb) { cb(fetchResult, null, status) }
        })
    }






    getLabel(dataObject) {
        // console.log(dataObject)
        if (this.state.thing?.structure) {
            // let result = ''
            for (let i = 0; i < this.state.thing.structure.length; i++) {
                const structure = this.state.thing.structure[i];
                if (structure.dataObject == dataObject) {
                    return structure.label
                }
            }

        }
    }


    updateData = (newData) => {
        let data = this.state.data
        const widgetData = this.props.widget || this.props.data
        // console.log("UPDATE")
        // console.log(newData)
        // fetchResult.info.forEach(element => {
        this.setState({ show: false }, () => {
            data.labels.splice(0, 0, Date(new Date()))

            if (widgetData.characteristic && Array.isArray(widgetData.characteristic)) {
                widgetData.characteristic.forEach((characteristic, index) => {
                    if (newData && newData[characteristic] != null) {
                        data.datasets[index].data.splice(0, 0, newData[characteristic])
                    }
                })
            }

            // });
            console.log(data)
            this.setState({ data, show: true })

        })
        // data.splice(0, 0, { cDate: new Date(), data: newData })
        // data = { ...data, ...newData }
        // this.setState({ data })
        // console.log("updateData")
    }




    render() {
        // Support both widget and data props for backward compatibility
        const widgetData = this.props.widget || this.props.data
        const chartType = widgetData?.type || 'line'

        return (

            <div className={'thingInfoList '}>

                {this.state.show && (
                    <div className="w-100">
                        {chartType == "line" && (
                            <Chart chartType='line' />
                            // <Line
                            //     data={this.state.data}
                            //     options={this.state.timeChartOptions}
                            //     ref={el => this.chart = el}
                            //     height={this.state.width > 700 ? 130 : 300}
                            //     plugins={[zoom]}
                            // />
                        )}

                        {chartType == "bar" && (
                            <Chart chartType='bar' />
                            // <Bar
                            //     data={this.state.data}
                            //     options={this.state.timeChartOptions}
                            //     ref={el => this.chart = el}
                            //     height={this.state.width > 700 ? 130 : 300}
                            // />
                        )}

                        {chartType == "pie" && (
                            <Chart chartType='pie' />
                            // <Pie
                            //     data={this.state.data}
                            //     options={this.state.timeChartOptions}
                            //     ref={el => this.chart = el}
                            // />
                        )}

                    </div>
                )}
            </div>

        )
    }


}


export default ChartWidget
